import { SENSOR_PAGE_KEYS } from '../../utilities/constants';

export const ROUTE_KEY_TO_SENSOR_TYPE_MAP = {
  [SENSOR_PAGE_KEYS.TRAP_SENSOR]: 'trap_sensor',
  [SENSOR_PAGE_KEYS.DETECTION_SENSOR]: 'detection_sensor',
  [SENSOR_PAGE_KEYS.BAIT_SENSOR]: 'bait_sensor',
  [SENSOR_PAGE_KEYS.OTHER_SENSOR]: 'other_sensor',
};
